export const iconFontAwesomeSocialShareFromSquare = (
	<i className="fa-solid fa-share-from-square"></i>
);
